import { Routes, Route, Navigate } from 'react-router-dom';
import { appInfo } from './app-info';
import { appRoutes } from './app-routes';
import { NavigationMenu } from './components';
import { UserSessionProvider } from './contexts/UserSessionContext';

export const Content = () => {
    return (
        <UserSessionProvider>
            <NavigationMenu title={appInfo.title}>
                <Routes>
                    {appRoutes.map(({ path, element }) => (
                        <Route key={path} path={path} element={element} />
                    ))}
                    <Route path='*' element={<Navigate to='/home' />} />
                </Routes>
            </NavigationMenu>
        </UserSessionProvider>
    )
}